import { EndPoints, post } from '../';
export function login(email, password) {
    var request = {
        email: email,
        password: password,
    };
    return post(EndPoints.login, request);
}
